import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import ArticlesList from './ArticlesList/ArticlesList';
import ArticleShow from './ArticleShow/ArticleShow';
import ArticleEdit from './ArticleEdit/ArticleEdit';
import ArticleCreate from './ArticleCreate/ArticleCreate';
import ArticleDelete from './ArticleDelete/ArticleDelete';

const Articles = ({ match }) => {
    return (
        <div className="Articles">
            <ContainerWrapper container="articles">
                <Route exact path={ match.path } component={ArticlesList} />
                <Route exact path={ `${ match.url }/new` } component={ArticleCreate} />
                <Route exact path={ `${ match.url }/new/:articleType` } component={ArticleCreate} />
                <Route exact path={ `${ match.url }/show/:articleId` } component={ArticleShow} />
                <Route exact path={ `${ match.url }/edit/:articleId` } component={ArticleEdit} />
                <Route exact path={ `${ match.url }/delete/:articleId` } component={ArticleDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Articles;
